import http from "@/components/services/http-common";

const ROOT_URL = "surveyReports";

export default class ReportApi {
  getBaseInfo = (id) => http.get(`${ROOT_URL}/${id}/base`).then(r => r.data)

  getRangeInfo = (id) => http.get(`${ROOT_URL}/${id}/range`).then(r => r.data)
}